import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css, CSSProperties} from 'styled-components'
import {DetailsFieldsSectionProps} from './DetailsAtoms'
import {EmptyState} from '@/components/commons/empty-state/EmptyState'

export const StyledDetailsPageWrapper = styled.div<{$isSuccess: boolean; $isDisabled?: boolean}>(
    ({theme: {palette, transition}, $isSuccess}) => css`
        background-color: ${palette.neutral['white']};
        border-radius: 8px;
        height: 100%;
        display: grid;
        grid-template-rows: ${$isSuccess ? 'auto minmax(0, 1fr)' : '1fr'};
        border: 1px solid ${palette.neutral[200]};
        overflow-y: hidden;
        transition: opacity ${transition};
    `
)

export const StyledDetailsPageContent = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-columns: 1fr 250px;
        grid-template-rows: minmax(0, 1fr);
        border-top: 1px solid ${palette.neutral[200]};
        height: 100%;
        overflow-y: hidden;
    `
)

export const StyledDetailsPageContentTabWrapper = styled.div`
    display: grid;
    grid-template-rows: 52px minmax(0, 1fr);
    height: 100%;
    overflow-y: hidden;
`

export const StyledDetailsSidebar = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: 52px minmax(0, 1fr);
        border-left: 1px solid ${palette.neutral[200]};
    `
)

export const StyledDetailsSidebarTabs = styled.div(
    ({theme: {palette, spacing}}) => css`
        border-bottom: 1px solid ${palette.neutral[200]};
        padding: ${spacing * 3}px ${spacing * 4}px;
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledDetailsSidebarContent = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px;
    `
)

export const StyledDetailsFieldsSection = styled.section<{
    $isDisabled: boolean
    $variant: NonNullable<DetailsFieldsSectionProps['variant']>
    $width?: CSSProperties['width']
    $height?: CSSProperties['height']
}>(
    ({theme: {palette}, $isDisabled, $variant, $width, $height}) => css`
        ${$variant == 'ghost'
            ? css`
                  border-bottom: 1px solid ${palette.neutral['200']};
              `
            : css`
                  border-radius: 6px;
                  border: 1px solid ${palette.neutral['200']};
              `}
        ${$isDisabled &&
        css`
            opacity: 0.3;
            pointer-events: none;
        `}
        ${$width &&
        css`
            width: ${$width};
        `}
        ${$height &&
        css`
            height: ${$height};
        `}
    `
)

export const StyledDetailsFieldsSectionHeading = styled(Flexbox)<{
    $variant: NonNullable<DetailsFieldsSectionProps['variant']>
}>(({theme: {spacing, palette}, $variant}) => {
    const variantToCss = {
        neutral: css`
            background-color: ${palette.neutral['50']};
        `,
        primary: css`
            background-color: ${palette.primary['50']};
        `,
        ghost: css`
            background-color: transparent;
        `
    }
    return css`
        border-radius: 6px;
        padding: ${spacing * 3}px;
        ${variantToCss[$variant]}
    `
})

export const StyledDetailsFieldsSectionBody = styled(Flexbox)<{$width?: CSSProperties['width']}>(
    ({theme: {spacing}, $width}) => css`
        width: ${$width ?? 'auto'};
        padding: ${spacing * 5}px ${spacing * 3}px;
    `
)

export const StyledDetailsFieldsGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${spacing * 4}px;
        width: 100%;
    `
)

interface StyledDetailsFieldsCardWrapperProps {
    $size: 'sm' | 'md'
}
export const StyledDetailsFieldsCardWrapper = styled(Flexbox)<StyledDetailsFieldsCardWrapperProps>(
    ({theme: {palette, spacing}, $size}) => css`
        border-radius: 12px;
        border: 1px solid ${palette.neutral[200]};
        padding: ${spacing * ($size == 'sm' ? 3 : 4)}px;
    `
)

export const StyledPlannedAccessEmptyState = styled(EmptyState)`
    min-height: 200px;
`
